// extracted by mini-css-extract-plugin
export default {"menuBlock":"xE-z","title":"yE-z","nav":"zE-z","flexCell":"AE-z","facetLink":"BE-z"};